module.exports = __webpack_public_path__ + "static/media/image (12).c2d7d82a.jpg";